import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import { getAntdThemeConfig } from '../../utils/antdTheme';
import {
  PageWrapper,
  PageTitle,
  SectionList,
  SectionRow,
  SectionContent,
  SectionTitle,
  SectionDescription,
  SectionButton,
} from './Styles';
import { PAGE_TITLE, SUPPORT_SECTIONS } from './constants';

const HelpSupport: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  const themeConfig = { mode: isDarkMode ? 'dark' : 'light' } as { mode: 'dark' | 'light' };

  return (
    <ThemeProvider theme={themeConfig}>
      <ConfigProvider theme={getAntdThemeConfig(isDarkMode)}>
        <PageWrapper>
          <PageTitle>{PAGE_TITLE}</PageTitle>
          <SectionList>
            {SUPPORT_SECTIONS.map((section) => (
              <SectionRow key={section.id}>
                <SectionContent>
                  <SectionTitle>{section.title}</SectionTitle>
                  <SectionDescription>{section.description}</SectionDescription>
                </SectionContent>
                <SectionButton type="default" aria-label={section.buttonLabel}>
                  {section.buttonLabel}
                </SectionButton>
              </SectionRow>
            ))}
          </SectionList>
        </PageWrapper>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default React.memo(HelpSupport);
